import type { MigrationRunStatus } from '@modules/Clients/ViewClient/adapters/MigrationApiAdapter';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { LegacyDashboardClient, LegacyPaymentProfile } from '../models/LegacyDashboardClient';

const PAYMENT_PROFILES: LegacyPaymentProfile[] = ['cod', 'card', 'mixed', 'other'];
const MIGRATION_STATUSES: MigrationRunStatus[] = ['pending', 'running', 'paused', 'completed', 'failed'];

export function useLegacyDashboardFilterOptions(clients: LegacyDashboardClient[]) {
  const { t } = useTranslation('legacyDashboardModule');

  return useMemo(() => {
    const channels = new Set<string>();
    const countries = new Set<string>();
    const migrationStatuses = new Set<MigrationRunStatus>();

    clients.forEach((client) => {
      client.shop_channels?.forEach((channel) => channels.add(channel));
      if (client.country_code) countries.add(client.country_code);
      if (client.migration_run_status) migrationStatuses.add(client.migration_run_status);
    });

    return {
      paymentProfileOptions: PAYMENT_PROFILES.map((value) => ({
        value,
        label: t(`payment_profile.${value}`),
      })),
      shopChannelOptions: Array.from(channels)
        .sort((a, b) => a.localeCompare(b))
        .map((value) => ({ value, label: value })),
      countryOptions: Array.from(countries)
        .sort((a, b) => a.localeCompare(b))
        .map((value) => ({ value, label: value })),
      migrationStatusOptions: MIGRATION_STATUSES.filter((status) => migrationStatuses.has(status)).map((value) => ({
        value,
        label: t(`migration_status.${value}`),
      })),
    };
  }, [clients, t]);
}
